import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GiCheckMark } from "react-icons/gi";
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import axios from 'axios';

const SuccessPage = () => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const eventName = searchParams.get('event_name') || 'Unknown Event';
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        insured_name: '',
        insured_address: '',
        insured_address_two: '',
        insured_city: '',
        insured_state: '',
        insured_zip: '',
        venue_name: '',
        venue_address: '',
        venue_address_two: '',
        venue_city: '',
        venue_state: '',
        venue_zip: '',
        additional_name: '',
        additional_address: '',
        additional_address_two: '',
        additional_city: '',
        additional_state: '',
        additional_zip: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            data.append('insured_name', formData.insured_name);
            data.append('insured_address', formData.insured_address);
            data.append('insured_address_two', formData.insured_address_two);
            data.append('insured_city', formData.insured_city);
            data.append('insured_state', formData.insured_state);
            data.append('insured_zip', formData.insured_zip);

            data.append('venue_name', formData.venue_name);
            data.append('venue_address', formData.venue_address);
            data.append('venue_address_two', formData.venue_address_two);
            data.append('venue_city', formData.venue_city);
            data.append('venue_state', formData.venue_state);
            data.append('venue_zip', formData.venue_zip);
            
            data.append('additional_name', formData.additional_name);
            data.append('additional_address', formData.additional_address);
            data.append('additional_address_two', formData.additional_address_two);
            data.append('additional_city', formData.additional_city);
            data.append('additional_state', formData.additional_state);
            data.append('additional_zip', formData.additional_zip);

            let baseUrl = process.env.REACT_APP_BASE_URL;
            const response = await axios.post(baseUrl + '/success-page', data, {
                headers: { 'Content-Type': 'multipart/form-data', },
            });

            console.log("Form Data:", response.data);
            setAlertType('success');
            setAlertMessage('Event stored successfully!');
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                navigate('/thank-you');
            }, 3000);
        } catch (err) {
            setAlertType('error');
            setAlertMessage('Failed to store Event. Please try again.');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 3000);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <section className="success-page">
                <Container>
                    <div className="success-page-content">
                        <GiCheckMark />
                        <h1>Post payment successful page</h1>
                        <p>Thank you for trusting us for your important event - <strong>{eventName}</strong></p>
                        <p>Payment Successful and receipt# <strong>{sessionId}</strong> sent to your email</p>
                        <p>Please provide the below insurer information to be included in policy certificate</p>
                    </div>
                    <div className="information-form">
                        {loading && <div>loading....</div>}
                        {showAlert && (
                            <Alert
                                variant={alertType === 'success' ? 'success' : 'danger'}
                                onClose={() => setShowAlert(false)}
                                dismissible
                            >
                                {alertMessage}
                            </Alert>
                        )}
                        <h1>Insurer and Venue information</h1>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <Row>
                                    <Col md={12} className='mb-3'>
                                        <label htmlFor='insured_name' className='form-label'>Insured Name</label>
                                        <input type='text' id='insured_name' name='insured_name' placeholder='Name' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={12} className='mb-3'>
                                        <label htmlFor='insured_address' className='form-label'>Insured Address</label>
                                        <input type='text' id='insured_address' name='insured_address' placeholder='Street' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='insured_address_two' placeholder='Address line 2' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='insured_city' placeholder='City' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='insured_state' placeholder='State' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='insured_zip' placeholder='ZIP' className='form-control' onChange={handleChange} onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, ""); }} required />
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row>
                                    <Col md={12} className='mb-3 mt-5'>
                                        <label htmlFor='venue_name' className='form-label'>Venue Name</label>
                                        <input type='text' id='venue_name' name='venue_name' placeholder='Name' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={12} className='mb-3'>
                                        <label htmlFor='venue_address' className='form-label'>Venue Address</label>
                                        <input type='text' id='venue_address' name='venue_address' placeholder='Street' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='venue_address_two' placeholder='Address line 2' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='venue_city' placeholder='City' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='venue_state' placeholder='State' className='form-control' onChange={handleChange} required />
                                    </Col>
                                    <Col md={6} className='mb-3'>
                                        <input type='text' name='venue_zip' placeholder='ZIP' className='form-control' onChange={handleChange} onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, ""); }} required />
                                    </Col>
                                </Row>

                            </div>
                            <Col md={12} className='mb-3 mt-4'>
                                <Form.Check label="Check for additional insurer to be included in policy" name="additional_insurer" type="checkbox" id="1"
                                    onChange={(e) => setShowAdditionalFields(e.target.checked)}
                                />
                            </Col>
                            {showAdditionalFields && (
                                <div>
                                    <Row>
                                        <Col md={12} className='mb-3'>
                                            <label htmlFor='additional_name' className='form-label'>Additional Insured Name</label>
                                            <input type='text' id='additional_name' name='additional_name' placeholder='Name' className='form-control' onChange={handleChange} />
                                        </Col>
                                        <Col md={12} className='mb-3'>
                                            <label htmlFor='additional_address' className='form-label'>Additional Insured Address</label>
                                            <input type='text' id='additional_address' name='additional_address' placeholder='Street' className='form-control' onChange={handleChange} />
                                        </Col>
                                        <Col md={6} className='mb-3'>
                                            <input type='text' name='additional_address_two' placeholder='Address line 2' className='form-control' onChange={handleChange} />
                                        </Col>
                                        <Col md={6} className='mb-3'>
                                            <input type='text' name='additional_city' placeholder='City' className='form-control' onChange={handleChange} />
                                        </Col>
                                        <Col md={6} className='mb-3'>
                                            <input type='text' name='additional_state' placeholder='State' className='form-control' onChange={handleChange} />
                                        </Col>
                                        <Col md={6} className='mb-3'>
                                            <input type='text' name='additional_zip' placeholder='ZIP' className='form-control' onChange={handleChange} onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, ""); }} />
                                        </Col>
                                    </Row>
                                </div>
                            )}
                            <Row>
                                <Col md={12} className='mb-4'>
                                    <button type='submit' className='event__form__btn'>Get Started</button>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </Container>
            </section >
        </>
    );
};

export default SuccessPage;
